<div class="sample-card">
    <div class="detail-wrapper" [class.active-plant]="showClass('plant')" [class.active-harvest]="showClass('harvest')">
        <div class="sample-avatar">
            <ng-container *ngIf="sample.primaryImage as image; else sampleIcon">
                <pv-image-ref
                    transformId="thumb_300"
                    [fileRef]="image.fileRef">
                </pv-image-ref>
            </ng-container>
            <ng-template #sampleIcon>
                <mat-icon *ngIf="sample.scionCultivar?.cropId as cropId; else typeIcon" [svgIcon]="'common:' + cropId"></mat-icon>
                <ng-template #typeIcon>
                    <mat-icon [svgIcon]="'common:' + sample.type + '_sample'"></mat-icon>
                </ng-template>
            </ng-template>
        </div>
        <div class="sample-detail">
            <div class="heading">
                <div class="title clip-text"
                    [class.title-overflowing]="isTitleOverflowing"
                    (mouseenter)="checkTitleOverflow($event)">
                    <span class="title-text">{{ sample.label || 'No Label' }}</span>
                </div>
            </div>

            <div class="sub-title clip-text" *ngIf="sample.scionCultivar?.commonName as cultivarName">{{ cultivarName }}</div>

            <div class="sub-title clip-text">{{ sample.site | descSite }}</div>

            <ng-container *ngIf="sample.type == 'harvest'; else plantDate">
                <div class="sub-title">
                    {{sample.birthDate | amDateFormat: '[W] W'}},
                    <time>{{ sample.birthDate | amDateFormat:'Y' }}</time>
                </div>
            </ng-container>
            <ng-template #plantDate>
                <div class="sub-title">
                    <time>{{ sample.birthDate | amDateFormat:'Y' }}</time>
                </div>
            </ng-template>

            <div class="sub-title clip-text">{{ (sample | rowPosition) || 'No Row Data'}}</div>
        </div>
    </div>

    <div class="card-indicator" [class.bg-plant]="showClass('plant')" [class.bg-harvest]="showClass('harvest')"></div>
</div>